import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guestlayout',
  templateUrl: './guestlayout.component.html',
  styleUrls: ['./guestlayout.component.scss']
})
export class GuestlayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
